<template>
  <div class="sub-content">
    <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class="bom-main float-left">
      <dx-data-grid
        ref="refBomMainGrid"
        :data-source="prodctInfoList"
        :show-borders="true"
        :showRowLines="false"
        :showColumnLines="true"
        :hover-state-enabled="true"
        :allowColumnResizing="true"
        column-resizing-mode="widget"
        :allow-column-reordering="true"
        :height="gridHeight"
        :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        :focused-row-key.sync="focusedRowKey"
        @toolbar-preparing="onToolbarPreparing"
      >
        <DxSearchPanel :visible="true" placeholder="검색..." />
        <DxExport :enabled="true" file-name="완제품리스트" />
        <DxFilterRow :visible="true" apply-filter="auto" />
        <DxColumnFixing :enabled="true" />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :allowEditing="true"
          :fixed="true"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :visible="true"
          sort-order="asc"
        >
          <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :fixed="true"
          caption="품번"
          data-field="품번"
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="품명"
          data-field="품명"
          :visible="true"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="공정유형"
          data-field="공정유형"
          :visible="true"
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="자재유형"
          data-field="자재유형"
          :visible="true"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="단위"
          data-field="단위"
          :visible="true"
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="사용유무"
          data-field="사용유무"
          :visible="false"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="삭제유무"
          data-field="삭제유무"
          :visible="false"
        >
        </DxColumn>
        <DxColumn type="buttons" caption="BOM추가">
          <DxButtonGrid icon="plus" :onClick="onAddBom"></DxButtonGrid>
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format="#,##0"
            show-in-column="차종"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false" />
        <dx-scrolling
          mode="virtual"
          showScrollbar="always"
          :useNative="false"
        />
        <dx-sorting mode="multiple" />
      </dx-data-grid>
    </div>
    <!-- *************************************** SUB ***************************-->
    <div class="bom-sub float-left">
      <dx-tree-list
        ref="refBomSubGrid"
        :height="gridHeight"
        :data-source="bomInfoList"
        :autoExpandAll="true"
        :show-borders="true"
        :showRowLines="true"
        :column-auto-width="true"
        :hover-state-enabled="true"
        key-expr="seqId"
        parent-id-expr="상위키"
        :selection="{ mode: 'single' }"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionSubChanged"
        :focused-row-key.sync="focusedRowKeyBom"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @toolbar-preparing="onToolbarPreparingSub"
        @cell-prepared="onCellPreparedBom"
        @row-updated="onRowUpdatedBom"
        @row-removed="onRowRemovedBom"
        @row-removing="onRowRemovingBom"
      >
        <DxSearchPanel :visible="true" placeholder="검색..." />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :allow-adding="false"
          :use-icons="true"
          mode="row"
        >
        </DxEditing>
        <DxColumn
          :allowEditing="false"
          caption="품번"
          data-field="품번"
          :visible="true"
        >
        </DxColumn>
        <DxColumn :allowEditing="false" caption="품명" data-field="품명">
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="원수"
          data-field="수량"
          format="#,##0.00000"
          dataType="number"
        >
          <dx-required-rule message="항목을 입력하세요" />
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          caption="단위"
          data-field="단위"
          :visible="true"
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          caption="품목유형"
          data-field="품목유형"
          :visible="true"
        >
          <DxLookup
            :data-source="goodsLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="사용유무"
          data-field="사용유무"
          :visible="true"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          caption="삭제유무"
          data-field="삭제유무"
          :visible="false"
        >
        </DxColumn>
        <dx-paging :enabled="false" />
        <dx-scrolling
          mode="virtual"
          showScrollbar="always"
          :useNative="false"
        />
        <dx-sorting mode="multiple" />
        <template #bom-sub>
          <div class="toolbar-label" style="font-size:1.2rem;margin-left:0px;">
            <b v-if="selectedRow"
              >BOM ({{ selectedRow.품명 }} : {{ selectedRow.품번 }})</b
            >
          </div>
        </template>
      </dx-tree-list>
    </div>
    <!-- *************************************** productInfoListByType ***************************-->
    <div
      class="product-list float-left"
      style="overflow:hidden;display:block; width:0%; margin-left:10px;"
    >
      <dx-data-grid
        ref="productGrid"
        :data-source="productInfoListByType"
        :show-borders="true"
        :showRowLines="false"
        :showColumnLines="true"
        :hover-state-enabled="true"
        :allowColumnResizing="true"
        column-resizing-mode="widget"
        :allow-column-reordering="true"
        :height="gridHeight"
        :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        :selected-row-keys.sync="selectedRowKeys"
        key-expr="품번"
        @toolbar-preparing="onToolbarPreparingProduct"
      >
        <DxSearchPanel :visible="true" placeholder="검색..." />
        <DxSelection :mode="selectionMode" show-check-boxes-mode="always" />
        <DxFilterRow :visible="true" apply-filter="auto" />
        <DxColumnFixing :enabled="true" />
        <DxColumn
          :allowEditing="false"
          caption="품번"
          data-field="품번"
          :visible="true"
        >
        </DxColumn>
        <DxColumn :allowEditing="false" caption="품명" data-field="품명">
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="소재중량"
          data-field="자사중량"
          :visible="isPurchase()"
          format="#,##0.0000"
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="품목유형"
          data-field="품목유형"
          :visible="true"
        >
          <DxLookup
            :data-source="goodsLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="자재유형"
          data-field="자재유형"
          :visible="true"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="공정유형"
          data-field="공정유형"
          :visible="true"
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format="#,##0"
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false" />
        <dx-scrolling
          mode="standard"
          showScrollbar="always"
          :useNative="false"
        />
        <dx-sorting mode="multiple" />
      </dx-data-grid>
    </div>
    <DxPopupGen
      :visible.sync="popupCloneBom"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="400"
      :height="200"
      title="BOM 복사"
    >
      <div class="form">
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">변경 완제품코드 :</div>
            <div class="dx-field-value">
              <DxTextBox
                :show-clear-button="true"
                :value.sync="cloneGoodsCode"
              />
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">변경 납입완제품코드 :</div>
            <div class="dx-field-value">
              <DxTextBox
                :show-clear-button="true"
                :value.sync="cloneVendorGoodsCode"
              />
            </div>
          </div>
        </div>
        <div class="dx-button-set">
          <div class="float-left" style="margin-right:10px">
            <DxButton
              :width="60"
              :height="40"
              text="복사"
              type="success"
              @click="onClickCloneBom()"
            />
          </div>
          <div class="float-left">
            <DxButton
              :width="60"
              :height="40"
              text="취소"
              type="danger"
              @click="popupCloneBom = false"
            />
          </div>
        </div>
      </div>
    </DxPopupGen>
    <loading
      :active.sync="isLoading"
      color="rgb(2, 110, 156)"
      loader="bars"
    ></loading>
  </div>
  <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxFilterRow,
  DxExport,
  DxColumnFixing,
  DxTotalItem,
  DxSummary,
  DxColumn,
  DxPaging,
  DxSorting,
  DxEditing,
  DxSearchPanel,
  DxSelection,
  DxButton as DxButtonGrid,
  DxLookup
} from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import { DxTreeList } from 'devextreme-vue/tree-list'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import DxTextBox from 'devextreme-vue/text-box'
import DxButton from 'devextreme-vue/button'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      // 제품리스트
      prodctInfoList: null,
      gridHeight: null,
      selectedRow: null,
      focusedRowKey: null,
      itemTypeLookup: null,
      unitLookup: null,
      carTypeLookup: null,
      bomReportFile: null,
      // BOM
      bomInfoList: null,
      goodsLookup: null,
      focusedRowKeyBom: null,
      selectedRowBom: null,
      currentBomDataSource: null,
      insertMode: 'down',
      // product
      productInfoListByType: null,
      selectedPrductType: ConstDef.구매품,
      productypeLookup: null,
      selectedRowKeys: [],
      meterialTypeLookup: null,
      addButton: null,
      selectionMode: 'multiple',
      // bom clone popuo
      popupCloneBom: false,
      cloneGoodsCode: null,
      cloneVendorGoodsCode: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxSelection,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxRequiredRule,
    DxTreeList,
    DxPopupGen,
    DxTextBox,
    DxButton,
    DxButtonGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }

    this.itemTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.공정유형
    )
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.자재유형
    )
    this.goodsLookup = this.productypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.품목유형
    )
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.carTypeLookup = this.$store.getters.getCarType
    this.refreshProductList(null)
    this.refreshProductListByType(this.selectedPrductType)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {},
  beforeDestroy: function () {},
  methods: {
    // ****************** 제품 Grid ************************************
    onAddBom (e) {
      if (this.bomInfoList.length > 0) return
      let temp = {
        품번: this.selectedRow.품번,
        품명: this.selectedRow.품명,
        수량: 1,
        상위품번: null,
        상위키: null,
        최상위품번: this.selectedRow.품번,
        품목유형: this.selectedRow.품목유형,
        사용유무: true,
        삭제유무: false,
        createid: this.userInfo.userId,
        updateid: this.userInfo.userId
      }
      this.saveBomlist([temp], 1)
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
        // console.log(this.selectedRow)
      }
      this.bomReportFile = `BOM_${this.selectedRow.품명}_${this.selectedRow.품번}`
      this.refreshBomList(this.selectedRow.품번)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: function () {
          return `<div class="toolbar-label" style='margin-left:4px;'><b>완제품</b></div>`
        }
      })
    },
    refreshProductList (focusCode) {
      this.isLoading = true
      // this.$_sp.runNoEncodeFindProc('spFindAllProductByS0100OrS0409WidthGroupCode', null) // group code===차종
      this.$_sp
        .runNoEncodeFindProc('spFindAllProductByS0100OrS0409', {
          양산차종: null
        }) // group code===차종
        .then(data => {
          this.prodctInfoList = this.$_sp.MakeModel(data)
          this.isLoading = false
          this.focusedRowKey = focusCode
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ****************** BOM Grid ************************************
    addBomList () {
      if (this.selectedRow === null) {
        this.$snotify.error('선택된 제픔이 없습니다.')
        return
      }
      this.$Q('.bom-main').css('width', '20%')
      this.$Q('.bom-sub').css('width', '39%')
      this.$Q('.product-list').css('width', '38%')
    },
    cloneBomList () {
      if (this.selectedRow === null) {
        this.$snotify.info('복사대상 완제품을 선택하여 주세요')
        return
      }
      this.popupCloneBom = true
      this.cloneGoodsCode = this.selectedRow.품번
      this.cloneVendorGoodsCode = this.selectedRow.납입품번
    },
    onCellPreparedBom (e) {
      if (
        e.rowType === 'data' &&
        (e.column.command === 'edit' || e.column.command === 'delete')
      ) {
        // // console.log(e)
        // if (e.data.상위품번 === null) {
        //   this.$Q(e.cellElement).find('.dx-icon-edit').remove()
        //   this.$Q(e.cellElement).find('.dx-icon-trash').remove()
        // }
      }
    },
    async onClickCloneBom () {
      // console.log(this.cloneGoodsCode)
      if (this.cloneGoodsCode === this.selectedRow.품번) {
        this.$snotify.info('변경할 완제품 코드를 입력하여 주세요')
        return
      }
      if (this.cloneVendorGoodsCode === this.selectedRow.납입품번) {
        this.$snotify.info('변경할 납입 완제품 코드를 입력하여 주세요')
        return
      }
      // check BOM등록여부
      this.isLoading = true
      await this.$_sp
        .runNoEncodeFindSqlProc('BOM정보', { 품번: this.cloneGoodsCode })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.isLoading = false
          }
        })
      if (this.isLoading === false) {
        this.$snotify.info(
          `${this.cloneGoodsCode} 품번은 이미 BOM에 등록 되어 있습니다.`
        )
      }

      let cloneSourceInfo = null
      let clonePriceInfo = null
      let lastSeqId = null
      let pressCoilCost = null
      await axios
        .all([
          this.$_sp.runNoEncodeFindSqlProc('품목정보', {
            품번: this.selectedRow.품번
          }),
          this.$_sp.runNoEncodeFindProc('spFindAllSalesPriceByGoodsNo', {
            품번: this.selectedRow.품번
          }),
          this.$_sp.runNoEncodeFindProc('spFindLastSeqIdByBOM정보', null),
          this.$_sp.runNoEncodeFindSqlProc('프레스재료비정보', {
            품번: this.selectedRow.품번
          })
        ])
        .then(
          axios.spread((...reponse) => {
            cloneSourceInfo = this.$_sp.MakeModel(reponse[0])
            clonePriceInfo = this.$_sp.MakeModel(reponse[1])
            lastSeqId = this.$_sp.MakeModel(reponse[2])[0].lastSeqId + 10
            pressCoilCost = this.$_sp.MakeModel(reponse[3])
            if (cloneSourceInfo.length === 0 || clonePriceInfo === 0) {
              this.isLoading = false
            }
            cloneSourceInfo[0].품번 = this.cloneGoodsCode
            cloneSourceInfo[0].납입품번 = this.cloneVendorGoodsCode
            clonePriceInfo[0].품번 = this.cloneGoodsCode
            if (pressCoilCost.length > 0) {
              pressCoilCost[0].품번 = this.cloneGoodsCode
            }
          })
        )

      if (this.isLoading === false) {
        this.$snotify.info(
          `${this.selectedRow.품번} 품목정보를 검색할 수 없습니다.`
        )
        return
      }

      let dataSource = this.$refs.refBomSubGrid.instance.getDataSource()._items
      let cloneList = []
      dataSource.forEach(item => {
        let clone = this.$Q.extend(true, {}, item.data)
        clone.updateid = clone.createid = this.userInfo.userId
        clone.최상위품번 = this.cloneGoodsCode
        clone.seqId = lastSeqId++
        if (item.level === 0) {
          clone.품번 = this.cloneGoodsCode
        } else if (item.level === 1) {
          clone.상위품번 = this.cloneGoodsCode
          clone.상위키 = this.$_.findWhere(cloneList, {
            품번: this.cloneGoodsCode
          }).seqId
        } else {
          clone.상위키 = cloneList[cloneList.length - 1].seqId
        }
        cloneList.push(clone)
      })
      // console.log(cloneList)
      await axios
        .all([
          this.$_sp.runInsertSqlProc('품목정보', null, cloneSourceInfo),
          this.$_sp.runInsertSqlProc(
            '가격정보_판매가',
            ['seqId'],
            clonePriceInfo
          ),
          this.$_sp.runInsertSqlProc(
            'BOM정보',
            [
              '삭제유무',
              '사용유무',
              '품목유형',
              '자재유형',
              '공정유형',
              '단위',
              'createtime',
              'updatetime'
            ],
            cloneList
          ),
          this.$_sp.runInsertSqlProc('프레스재료비정보', null, pressCoilCost)
        ])
        .then(
          axios.spread((...reponse) => {
            this.isLoading = false
            this.popupCloneBom = false
            this.refreshProductList(this.cloneGoodsCode)
            if (pressCoilCost.length > 0) {
              this.updatePressPurchasePrice()
            }
            this.$snotify.info(
              '복사 되었습니다.(판매가 및 프레스품인 경우 원자재 규격 및 구입가 채크 하여주세요)'
            )
          })
        )
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    updatePressPurchasePrice (date) {
      this.$_sp
        .runUpdateProc('사용하지않음spRefreshPressPurchasePrice', null)
        .then(data => {})
    },
    async onRowRemovedBom (row) {
      console.log(row.data)
      let result = null
      await this.$_sp.runNoEncodeFindProc('spFindAllBomChildByCode', { 품번: row.data.품번, 완제품코드: row.data.최상위품번 })
        .then(data => {
          result = this.$_sp.MakeModel(data)
        })
      if (result.length > 0) {
        this.$_sp.runDeleteSqlProc('BOM정보', result)
          .then(data => {
            this.$_sp.runDeleteSqlProc('BOM정전개', [{ 완제품코드: row.data.최상위품번 }])
            this.$snotify.info('삭제 되었습니다.')
          })
      }
    },
    onRowRemovingBom (row) {
      this.currentBomDataSource = this.$refs.refBomSubGrid.instance.getDataSource()._items
      console.log(this.currentBomDataSource)
    },
    onRowUpdatedBom (row) {
      const param = [
        {
          seqId: row.data.seqId,
          updateid: this.userInfo.userId,
          updatetime: AppLib.getNow(),
          수량: row.data.수량,
          사용유뮤: row.data.사용유뮤
        }
      ]
      this.$_sp
        .runUpdateSqlProc('BOM정보', ['seqId'], null, param)
        .then(data => {
          // this.$snotif.info('저장 되었습니다.')
          this.$_sp.deleteForwardBom(this.selectedRow.품번)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSelectionSubChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowBom = e.row.data
        // console.log(this.selectedRowBom)
      }
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'bom-sub'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '추가',
            icon: 'add',
            text: '하위품목추가',
            type: 'default',
            focusStateEnabled: true,
            onClick: args => {
              this.insertMode = 'down'
              this.selectionMode = 'multiple'
              this.addButton.option({ text: '품목 하위BOM 추가' })
              this.addBomList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '추가',
            icon: 'add',
            text: '상위품목추가',
            type: 'default',
            focusStateEnabled: true,
            onClick: args => {
              if (this.selectedRowBom.상위품번 === null) {
                this.$snotify.info(
                  '최상위품번의 상위품번 추가는 할 수 없습니다.'
                )
                return
              }
              this.insertMode = 'up'
              this.selectionMode = 'single'
              this.addButton.option({ text: '품목 상위BOM 추가' })
              this.addBomList()
            }
          }
        }
        // {
        //   location: 'after',
        //   widget: 'dxButton',
        //   options: {
        //     hint: '복사',
        //     icon: 'copy',
        //     text: 'BOM복사',
        //     type: 'success',
        //     focusStateEnabled: true,
        //     onClick: (args) => {
        //       this.cloneBomList()
        //     }
        //   }
        // }
      )
    },
    refreshBomList (parentCode) {
      this.isLoading = true
      this.$_sp
        .runNoEncodeFindProc('spFindAllBomByParentCodeTree', {
          최상위품번: parentCode
        })
        .then(data => {
          this.bomInfoList = this.$_sp.MakeModel(data)
          console.log(this.bomInfoList)
          this.isLoading = false
          if (this.bomInfoList.length > 0) {
            this.selectedRowBom = this.$_.findWhere(this.bomInfoList, {
              품번: this.selectedRow.품번
            })
            this.focusedRowKeyBom = this.selectedRowBom.seqId
            const vm = this
            setTimeout(() => {
              vm.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                vm.$refs.refBomSubGrid.instance.expandRow(node.key)
              })
            }, 100)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    update상위키 (seqId, childBom) {
      const param = {
        seqId: childBom.seqId,
        상위키: seqId
      }
      this.$_sp
        .runUpdateSqlProc('BOM정보', ['seqId'], null, [param])
        .then(data => {})
    },
    // **************** product list ********************************
    isPurchase () {
      return this.selectedPrductType === ConstDef.구매품
    },
    onToolbarPreparingProduct (e) {
      let productypeLookup = this.$_.reject(this.productypeLookup, function (d) {
        return d.코드 === ConstDef.완제품
      })
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            type: 'success',
            hint: '품목추가',
            icon: 'add',
            text: '품목 하위BOM 추가',
            focusStateEnabled: true,
            onInitialized: args => {
              this.addButton = args.component
            },
            onClick: args => {
              console.log(this.selectedRowKeys)
              if (this.selectedRowKeys.length === 0) {
                this.$snotify.info('선택된 품목이 없습니다.')
                return
              }
              if (this.insertMode === 'down') {
                this.addDownBom()
              } else {
                this.addUpBom()
              }
            }
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 100,
            items: productypeLookup,
            valueExpr: '코드',
            displayExpr: '코드명',
            value: this.selectedPrductType,
            onValueChanged: args => {
              this.selectedPrductType = args.value
              this.refreshProductListByType(this.selectedPrductType)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'close',
            text: '닫기',
            focusStateEnabled: true,
            onClick: args => {
              this.$Q('.bom-main').css('width', '40%')
              this.$Q('.bom-sub').css('width', '58%')
              this.$Q('.product-list').css('width', '0%')
            }
          }
        }
      )
    },
    addDownBom () {
      let row = 0
      // console.log(this.productInfoListByType)
      const arrayTemp = []
      for (let i = 0; i < this.selectedRowKeys.length; i++) {
        if (
          this.$_.findIndex(this.bomInfoList, {
            상위키: this.selectedRowBom.seqId,
            품번: this.selectedRowKeys[i]
          }) >= 0
        ) {
          continue
        }
        let where = this.$_.findWhere(this.productInfoListByType, {
          품번: this.selectedRowKeys[i]
        })
        let qty = 1
        if (where.자사중량 !== null && where.자사중량 !== undefined) {
          qty = where.자사중량
        }

        let temp = {
          품번: where.품번,
          품명: where.품명,
          수량: qty,
          상위품번: this.selectedRowBom.품번,
          상위키: this.selectedRowBom.seqId,
          최상위품번: this.selectedRow.품번,
          품목유형: where.품목유형,
          사용유무: true,
          삭제유무: false,
          createid: this.userInfo.userId,
          updateid: this.userInfo.userId
        }
        arrayTemp.push(temp)
        row++
      }
      // console.log(arrayTemp)
      this.saveBomlist(arrayTemp, row)
    },
    async addUpBom () {
      let where = this.$_.findWhere(this.productInfoListByType, {
        품번: this.selectedRowKeys[0]
      })
      let qty = 1
      let temp = {
        품번: where.품번,
        품명: where.품명,
        수량: qty,
        상위품번: this.selectedRowBom.상위품번,
        상위키: this.selectedRowBom.상위키,
        최상위품번: this.selectedRowBom.최상위품번,
        사용유무: true,
        삭제유무: false,
        createid: this.userInfo.userId,
        updateid: this.userInfo.userId
      }
      let insertResult = null
      await this.$_sp
        .runInsertAndFindSqlProc(
          'BOM정보',
          ['품번', '상위품번', '최상위품번'],
          null,
          temp
        )
        .then(data => {
          insertResult = this.$_sp.MakeModel(data)[0]
          console.log(insertResult)
        })
      // 하위item update
      const updateArray = []
      where = this.$_.where(this.bomInfoList, {
        상위품번: this.selectedRowBom.상위품번
      })
      where.forEach(item => {
        const temp1 = {
          seqId: item.seqId,
          상위품번: temp.품번,
          상위키: insertResult.seqId
        }
        updateArray.push(temp1)
      })
      this.$_sp
        .runUpdateSqlProc('BOM정보', ['seqId'], null, updateArray)
        .then(data => {
          this.$_sp.deleteForwardBom(this.selectedRow.품번)
          this.refreshBomList(this.selectedRow.품번)
        })
    },
    refreshProductListByType (type) {
      if (type === ConstDef.구매품) {
        this.$_sp
          .runNoEncodeFindProc('spFindAllMeterialWthWeight', {
            자재유형: 'ALL'
          })
          .then(data => {
            this.productInfoListByType = this.$_sp.MakeModel(data)
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      } else {
        this.$_sp
          .runNoEncodeFindProc('spFindAllSemiBomByProductType', {
            품목유형: type
          })
          .then(data => {
            this.productInfoListByType = this.$_sp.MakeModel(data)
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    async saveBomlist (list, row) {
      this.$refs.productGrid.instance.clearSelection()
      if (row === 0) {
        this.$snotify.info('이미 등록된 품목입니다.')
        return
      }
      this.isLoading = true
      this.$_sp
        .runUpdateProc('spSaveBom', list)
        .then(data => {
          this.isLoading = false
          if (row > 1) {
            this.$snotify.info(
              `${row}행 등록 하였습니다. 수량 수정후 저장하여 주세요.`
            )
          }
          this.$_sp.deleteForwardBom(this.selectedRow.품번)
          this.refreshBomList(this.selectedRow.품번)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.sub-content {
  .bom-main {
    width: 40%;
    margin-right: 2%;
    border: 0px solid red;
    min-height: 500px;
  }
  .bom-sub {
    width: 58%;
    border: 0px solid red;
    min-height: 500px;
  }
}
.dx-button-set {
  overflow: hidden;
  margin-top: 20px;
  padding-left: 200px;
}
</style>
